import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const IconPlus = () => {
    return (
        <svg
            fill='none'
            height='20'
            viewBox='0 0 20 20'
            width='20'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                clipRule='evenodd'
                d='M9.5 10.5V20H10.5V10.5L20 10.5V9.5L10.5 9.5V0H9.5V9.5L0 9.5V10.5L9.5 10.5Z'
                fill='black'
                fillRule='evenodd'/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {};

IconPlus.propTypes = propTypes;

export default IconPlus;
